import { apiClientManager } from '@common/api';
export async function getServerConfig() {
    const r = await apiClientManager.getClient().get('/api/configs');
    return r.data;
}
